import {
  ENDPOINT_PRODUCTS_QUICK_ENTRY,
  ENDPOINT_ROOT,
  QUICK_ENTRY_TERM,
  TERM_KEY_PARAM,
} from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const getQuickEntry = (apiParams) => {
  const params = {
    [QUICK_ENTRY_TERM]: apiParams[TERM_KEY_PARAM],
    packaging: 1,
  };

  return axiosAuth
    .get(`${ENDPOINT_ROOT}/${ENDPOINT_PRODUCTS_QUICK_ENTRY}`, { params })
    .then((res) => res.data);
};

export default getQuickEntry;
